import { render, staticRenderFns } from "./usereportbb.vue?vue&type=template&id=36fefa5e&scoped=true&"
import script from "./usereportbb.vue?vue&type=script&lang=js&"
export * from "./usereportbb.vue?vue&type=script&lang=js&"
import style0 from "./usereportbb.vue?vue&type=style&index=0&id=36fefa5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fefa5e",
  null
  
)

export default component.exports